export default __webpack_public_path__ + "static/media/visa.81165255.svg";